module.exports = __webpack_public_path__ + "img/shipo-icon-arrow-left.8ffae1b5.svg";